<template>
    <MainPage v-if="levelInfo" @clickBack="clickBack()">
        <div class="max-w-3xl mt-4 lg:mt-0 mx-4 lg:mx-auto">
            <div class="pt-2 lg:pt-4 min-h-100px border border-a-brown-d7c7b8 rounded-20">
                <TabLevel :tabs="levelInfo" @clickTab="updateSelectedTab($event)"></TabLevel>
                <div class="px-3 py-4 lg:p-6">
                    <div class="mb-2 font-bold text-16 lg:text-18 text-a-brown-502314">{{getMultiLangInfo('header')}}</div>
                    <div class="mb-6 text-14 lg:text-16 text-a-brown-502314">{{lbl.tierlevel.sub_title}}</div>
                    <BenefitsList :benefits="levelInfo[selectedTab].benefits"> </BenefitsList>
                    <div class="mb-3 font-bold text-16 lg:text-18 text-a-brown-502314">{{lbl.tierlevel.condition_title}}</div>
                    <div class="mb-3 text-14 lg:text-16 text-a-brown-502314 leading-18px">
                        <div v-html="getMultiLangInfo('condition')"></div>
                    </div>
                </div>
            </div>
        </div>
    </MainPage>
</template>
<script>
import Util from "@/helper/Utility";
//mixins
import LocaleMixin from "@/mixin/LocaleMixin";
//component
import MainPage from "@/components/Layout/Page/MainPage.vue";
import TabLevel from "@/module/TierLevel/component/TabLevel.vue";
import BenefitsList from "@/module/TierLevel/component/BenefitsList.vue"
//service
import TierLevelService from "@/module/TierLevel/service/TierLevelService.js";
export default {
    name: "TierLevel",
    mixins: [LocaleMixin],
    components: {
        MainPage,
        TabLevel,
        BenefitsList,
    },
    data: function() {
        return {
            levelInfo: null,
            selectedTab: 0,
        }
    },
    created: function() {
        this.getTierLevel();
    },
    methods: {
        getMultiLangInfo: function(jsonKey){
            if(this.localeCode == 1033){
                jsonKey = jsonKey + '_en';
            }
            return Util.newLineToBr(this.levelInfo[this.selectedTab][jsonKey]);
        },
        getTierLevel: function(){
            return new Promise((resolve)=>{
                TierLevelService.apiGetTierLevel().subscribe({
                    next: (data) => {
                        this.levelInfo = data.level;
                        console.log('getTierLevel');
                        console.log(this.levelInfo);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            })
        },
        updateSelectedTab: function(tabInfo){
            this.selectedTab = tabInfo.index;
        },
        clickBack: function(){
            this.$router.back();
        }
    },

}
</script>
